import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, lastValueFrom } from "rxjs";
import { ApiService } from "./api.service";

@Injectable()
export class GitVersionService {
	public Client: BehaviorSubject<string> = new BehaviorSubject<string>("");
	public Server: BehaviorSubject<string> = new BehaviorSubject<string>("");

	constructor(private http: HttpClient, private api: ApiService) {
		lastValueFrom(this.http.get("/assets/gitversion.txt", { responseType: "text" })).then(version => {
			this.Client.next(version);
		}).catch(err => {
			console.log("Couldn't get client version");
			console.log(err);
		});
		api.GitVersion().then(version => {
			this.Server.next(version);
		}).catch(err => {
			console.log("Couldn't get API version");
			console.log(err);
		});
	}

}
